import React from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { i18nTranslate } from 'src/utils'
import { mysiteContainer } from 'src/models/Mysite'
import { Button, Col, Container, Row } from 'react-bootstrap'
import './styles.scss'
@observer
class MysiteNotFound extends React.Component {
  notFoundLogo = (
    <svg
      width="298"
      height="298"
      viewBox="0 0 298 298"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="mysite-not-found-logo-svg">
      <path
        d="M269.506 73.8516V89.2957"
        stroke="#641034"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M261.777 81.5741H277.233"
        stroke="#641034"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M62.459 29.957V43.5985"
        stroke="#641034"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M55.6328 36.7773H69.2844"
        stroke="#641034"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M239.171 163.601C239.171 164.469 238.913 165.319 238.43 166.041C237.947 166.763 237.26 167.326 236.457 167.658C235.654 167.991 234.77 168.078 233.917 167.908C233.064 167.739 232.281 167.32 231.666 166.706C231.052 166.092 230.633 165.309 230.463 164.457C230.294 163.605 230.381 162.722 230.713 161.919C231.046 161.117 231.609 160.43 232.332 159.948C233.055 159.465 233.905 159.207 234.774 159.207C235.94 159.207 237.059 159.67 237.883 160.494C238.708 161.318 239.171 162.435 239.171 163.601Z"
        stroke="#641034"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M36.9289 167.776C36.9287 168.645 36.6707 169.494 36.1876 170.217C35.7045 170.939 35.0179 171.502 34.2147 171.834C33.4115 172.167 32.5276 172.253 31.6749 172.084C30.8223 171.914 30.039 171.496 29.4243 170.882C28.8096 170.267 28.3909 169.485 28.2212 168.633C28.0516 167.781 28.1386 166.898 28.4712 166.095C28.8038 165.292 29.3671 164.606 30.0899 164.123C30.8127 163.641 31.6625 163.383 32.5319 163.383C33.6981 163.383 34.8164 163.846 35.641 164.67C36.4656 165.494 36.9289 166.611 36.9289 167.776Z"
        stroke="#641034"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M131.283 298C192.743 298 242.567 294.598 242.567 290.402C242.567 286.206 192.743 282.805 131.283 282.805C69.8232 282.805 20 286.206 20 290.402C20 294.598 69.8232 298 131.283 298Z"
        fill="#DFC8BC"
      />
      <path
        d="M240.875 54.7488C240.383 54.7486 239.893 54.6757 239.423 54.5323L107.18 14.3731C105.915 13.9889 104.855 13.1183 104.232 11.9527C103.609 10.7871 103.475 9.42215 103.86 8.15801C104.245 6.89388 105.116 5.83415 106.282 5.21196C107.449 4.58977 108.815 4.45608 110.08 4.84031L242.322 44.9994C243.466 45.347 244.446 46.0933 245.085 47.1024C245.724 48.1115 245.979 49.3164 245.803 50.4976C245.628 51.6788 245.034 52.7577 244.129 53.538C243.225 54.3183 242.07 54.748 240.875 54.7488Z"
        fill="#DFC8BC"
      />
      <path
        d="M108.625 4.96602C109.083 4.96653 109.539 5.0346 109.978 5.16803L242.224 45.3272C242.812 45.4999 243.361 45.7876 243.838 46.1734C244.315 46.5593 244.71 47.0358 245.002 47.5753C245.293 48.1148 245.475 48.7067 245.536 49.3167C245.597 49.9268 245.537 50.5429 245.359 51.1296C245.18 51.7162 244.887 52.2617 244.497 52.7345C244.106 53.2074 243.625 53.5982 243.083 53.8844C242.54 54.1706 241.946 54.3466 241.335 54.4021C240.724 54.4576 240.108 54.3915 239.523 54.2078L107.276 14.0495C106.21 13.7261 105.296 13.031 104.701 12.0907C104.105 11.1504 103.867 10.0276 104.031 8.92685C104.194 7.82607 104.748 6.82057 105.591 6.09355C106.434 5.36654 107.51 4.96639 108.624 4.96602M108.624 4.28125C107.347 4.28125 106.112 4.73988 105.145 5.57357C104.177 6.40726 103.542 7.56049 103.355 8.82308C103.167 10.0857 103.44 11.3735 104.123 12.452C104.806 13.5304 105.855 14.3276 107.077 14.6983L239.325 54.8634C240.677 55.2739 242.136 55.1309 243.382 54.466C244.629 53.8011 245.56 52.6688 245.97 51.318C246.381 49.9673 246.238 48.5088 245.573 47.2635C244.907 46.0181 243.774 45.0879 242.422 44.6775L110.175 4.51664C109.673 4.36301 109.15 4.28484 108.625 4.28467"
        stroke="#641034"
        stroke-width="1.2"
      />
      <path
        d="M163.29 127.874C153.972 127.868 144.785 125.683 136.464 121.493C128.142 117.303 120.918 111.225 115.368 103.745C109.819 96.2655 106.098 87.5917 104.505 78.4177C102.911 69.2437 103.488 59.8243 106.19 50.9132L116.167 18.1094L230.324 52.7758L220.348 85.5797C216.624 97.9581 208.942 108.775 198.478 116.374C188.252 123.809 175.94 127.833 163.294 127.874L163.29 127.874Z"
        fill="white"
      />
      <path
        d="M107.617 91.5781C111.933 99.0687 117.266 105.926 123.464 111.954C130.694 118.911 140.853 125.4 149.866 126.334C171.081 128.527 174.414 127.849 178.506 126.334C182.598 124.819 202.449 116.162 204.118 111.954C205.788 107.746 107.617 91.5781 107.617 91.5781Z"
        fill="#ECDBC7"
      />
      <path
        d="M154.733 106.178C181.07 111.772 202.915 113.982 203.525 111.114C204.135 108.247 183.279 101.387 156.942 95.7929C130.605 90.1989 108.759 87.9889 108.149 90.8567C107.539 93.7246 128.395 100.584 154.733 106.178Z"
        fill="#DFC8BC"
      />
      <path
        d="M116.391 17.6312L229.895 52.0991L220.018 84.5768C216.316 96.8841 208.678 107.639 198.274 115.195C190.853 120.629 182.267 124.259 173.196 125.796C164.126 127.334 154.821 126.737 146.022 124.053C138.569 121.79 131.635 118.082 125.617 113.141C119.598 108.2 114.612 102.123 110.944 95.2571C107.275 88.3908 104.996 80.8698 104.237 73.1234C103.477 65.377 104.252 57.557 106.517 50.1098L116.391 17.6312ZM115.937 16.7812L105.862 49.907C101.235 65.1201 102.846 81.5468 110.34 95.5733C117.833 109.6 130.596 120.077 145.821 124.7C161.045 129.324 177.484 127.714 191.521 120.226C205.558 112.738 216.043 99.9843 220.67 84.7711L230.746 51.6454L115.937 16.7812Z"
        stroke="#641034"
        stroke-width="1.2"
      />
      <path
        d="M188.284 243.892C187.842 243.892 187.402 243.833 186.975 243.716L53.5791 207.304C52.4117 206.98 51.4007 206.246 50.7323 205.236C50.0639 204.227 49.7831 203.01 49.9416 201.809C50.1001 200.609 50.6873 199.506 51.5949 198.705C52.5026 197.903 53.6696 197.455 54.8811 197.445C55.3233 197.445 55.7635 197.505 56.19 197.622L189.586 234.035C190.754 234.359 191.765 235.093 192.433 236.103C193.102 237.113 193.382 238.33 193.224 239.53C193.065 240.73 192.478 241.833 191.571 242.635C190.663 243.437 189.496 243.884 188.284 243.894"
        fill="#DFC8BC"
      />
      <path
        d="M188.284 243.892C187.842 243.892 187.402 243.833 186.975 243.716L53.5791 207.304C52.4117 206.98 51.4007 206.246 50.7323 205.236C50.0639 204.227 49.7831 203.01 49.9416 201.809C50.1001 200.609 50.6873 199.506 51.5949 198.705C52.5026 197.903 53.6696 197.455 54.8811 197.445C55.3233 197.445 55.7635 197.505 56.19 197.622L189.586 234.035C190.754 234.359 191.765 235.093 192.433 236.103C193.102 237.113 193.382 238.33 193.224 239.53C193.065 240.73 192.478 241.833 191.571 242.635C190.663 243.437 189.496 243.884 188.284 243.894"
        stroke="#641034"
        stroke-width="2"
      />
      <path
        d="M65.3164 200.316L74.2961 167.224C76.3344 159.655 79.8466 152.561 84.6316 146.35C89.4166 140.139 95.3806 134.932 102.182 131.026C108.984 127.121 116.489 124.595 124.269 123.592C132.049 122.589 139.95 123.129 147.521 125.181C155.091 127.233 162.183 130.757 168.389 135.551C174.595 140.345 179.794 146.315 183.688 153.119C187.583 159.923 190.096 167.428 191.084 175.204C192.072 182.98 191.516 190.875 189.447 198.436L180.46 231.528L65.3164 200.316Z"
        fill="white"
      />
      <path
        d="M92.6623 137.453C92.6623 137.453 89.3926 177.889 140.383 178.262C191.372 178.635 190.902 185.407 190.902 185.407C191.407 191.358 190.533 197.344 188.348 202.902C184.699 212.334 180.255 230.706 180.255 230.706L103.123 209.64L64.9453 199.072L73.7837 168.742C73.7837 168.742 77.0242 150.835 84.9632 144.993C92.9021 139.151 92.6623 137.453 92.6623 137.453Z"
        fill="#ECDBC7"
      />
      <path
        d="M140.71 122.928L126.624 163.864C126.624 163.864 127.725 165.491 128.868 164.889L153.972 128.018L140.71 122.928Z"
        fill="#ECDBC7"
      />
      <path
        d="M131.832 121.961V122.646C140.952 122.632 149.953 124.721 158.134 128.752C166.314 132.782 173.453 138.644 178.996 145.882C184.539 153.119 188.336 161.538 190.09 170.481C191.845 179.425 191.511 188.652 189.114 197.446L180.218 230.209L65.7314 199.172L74.6221 166.408C78.0296 153.851 85.477 142.762 95.8157 134.852C106.154 126.943 118.81 122.652 131.831 122.641L131.832 121.961ZM131.832 121.961C118.658 121.959 105.851 126.294 95.3908 134.297C84.9307 142.299 77.4006 153.522 73.9651 166.23L64.8945 199.651L180.696 231.042L189.776 197.621C192.182 188.728 192.506 179.4 190.723 170.361C188.941 161.322 185.099 152.815 179.496 145.499C173.893 138.182 166.679 132.254 158.414 128.172C150.149 124.09 141.054 121.965 131.834 121.961"
        stroke="#641034"
        stroke-width="1.3"
      />
      <path
        d="M125.544 173.823C127.295 174.008 128.865 172.739 129.05 170.989C129.234 169.239 127.965 167.671 126.214 167.487C124.463 167.302 122.893 168.571 122.708 170.321C122.524 172.07 123.793 173.639 125.544 173.823Z"
        fill="#ECDBC7"
      />
      <path
        d="M219.946 258H151.412C150.484 258 149.653 257.522 149.188 256.72C148.723 255.918 148.721 254.959 149.182 254.155L183.449 194.432C183.913 193.624 184.746 193.141 185.679 193.141C186.611 193.141 187.444 193.624 187.908 194.432L222.175 254.155C222.636 254.959 222.634 255.918 222.169 256.72C221.704 257.522 220.873 258 219.946 258Z"
        fill="#ECDBC7"
      />
      <path
        d="M185.679 192.785C186.671 192.785 187.655 193.275 188.218 194.255L222.484 253.979C223.602 255.927 222.195 258.356 219.946 258.356H151.412C149.163 258.356 147.755 255.927 148.873 253.979L183.141 194.255C183.703 193.275 184.687 192.785 185.679 192.785ZM185.679 193.497C185.307 193.497 184.336 193.603 183.759 194.608L149.492 254.332C148.918 255.333 149.311 256.222 149.497 256.542C149.683 256.863 150.259 257.645 151.412 257.645H219.946C221.1 257.644 221.675 256.861 221.86 256.541C222.046 256.221 222.44 255.333 221.866 254.332L187.599 194.608C187.021 193.603 186.051 193.497 185.679 193.497Z"
        fill="#641034"
        stroke="#641034"
      />
      <path
        d="M184.744 246.284C185.501 246.284 186.113 246.897 186.113 247.652C186.113 248.407 185.5 249.019 184.744 249.019C183.988 249.019 183.375 248.407 183.375 247.652C183.375 246.897 183.988 246.284 184.744 246.284Z"
        fill="#641034"
        stroke="#641034"
      />
      <path
        d="M184.744 217.338C185.501 217.338 186.113 217.951 186.113 218.706V240.181C186.113 240.936 185.501 241.549 184.744 241.549C183.988 241.549 183.375 240.936 183.375 240.181V218.706C183.375 217.951 183.988 217.338 184.744 217.338Z"
        fill="#641034"
        stroke="#641034"
      />
    </svg>
  )

  render() {
    const continueShopping = i18nTranslate(
      'notFoundPage.continueShopping',
      'Continue Shopping',
      {
        nameSpace: 'ssr-resource',
      }
    )
    const displayText = i18nTranslate(
      `mysite.${mysiteContainer.mysiteApiError}`,
      "Sorry, we couldn't find a sponsor with that Sponsor ID. Please try again.",
      {
        nameSpace: 'ssr-resource',
      }
    )
    return (
      <Container className="mysite-not-found-container">
        <div className="mysite-not-found-page">
          <Row className="mysite-not-found-logo">{this.notFoundLogo}</Row>
          <Col className="mysite-not-found-content">
            <Row className="mysite-not-found-text">{displayText}</Row>
            <Link to="/" className="mysite-not-found-button">
              <Button variant="primary" className="btn-font-size">
                {continueShopping}
              </Button>
            </Link>
          </Col>
        </div>
      </Container>
    )
  }
}
export { MysiteNotFound }
export default MysiteNotFound
